import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Polityki Prywatności</h2>
                <p><strong>Polityka prywatności Dreamehome</strong></p>
                <p><strong>Wprowadzenie</strong></p>
                <p>Działalność „Dreamehome” jest obsługiwana przez Dreamehome Innovation Technology (Suzhou) Co., LTD. i jej
                    podmioty
                    stowarzyszone (zwane dalej „nami” lub „Dreamehome”), zapewniając inteligentną platformę usług kontroli i
                    zarządzania
                    urządzeniami sprzętowymi (lub usługę). Rozumiemy znaczenie Twoich danych osobowych, dlatego tez dołożymy
                    wszelkich
                    starań, aby chronić Twoje dane osobowe. Podejmiemy odpowiednie środki bezpieczeństwa, aby chronić Twoje dane
                    osobowe
                    zgodnie z uznanymi w branży standardami bezpieczeństwa.</p>
                <p>Dlatego prosimy o uważne przeczytanie i zrozumienie niniejszej Polityki prywatności Dreamehome przed
                    skorzystaniem
                    z naszych produktów (lub usług).</p>
                <p>Jeśli jesteś osobą niepełnoletnią, użyj tej aplikacji za zgodą swojego opiekuna i zaakceptuj odpowiednie warunki
                    korzystania z usługi.</p>
                <p>Niniejsza Polityka prywatności została opracowana z myślą o Twoich potrzebach i ważne jest, abyś w pełni
                    zrozumiał
                    nasze praktyki gromadzenia i wykorzystywania danych osobowych, zapewniając jednocześnie, że ostatecznie masz
                    kontrolę nad przekazanymi nam danymi osobowymi. Niniejsza Polityka prywatności określa, w jaki sposób zbieramy,
                    wykorzystujemy, ujawniamy, przetwarzamy i przechowujemy informacje, które nam przekazujesz podczas korzystania z
                    naszej Aplikacji. Będziemy wykorzystywać te informacje ściśle zgodnie z niniejszą Polityką prywatności.</p>
                <p>Niniejsza Polityka prywatności pomoże Ci zrozumieć następujące:</p>
                <p>1. Jakie informacje zbieramy i jak je wykorzystujemy;</p>
                <p>2. W jaki sposób wykorzystujemy pliki cookies i podobne technologie;</p>
                <p>3. W jaki sposób powierzamy, udostępniamy, przekazujemy i publicznie ujawniamy Twoje dane osobowe;</p>
                <p>4. Jak przechowujemy i chronimy Twoje dane osobowe;</p>
                <p>5. Twoje prawa;</p>
                <p>6. Transgraniczna transmisja danych;</p>
                <p>7. Skontaktuj się z nami;</p>
                <p>8. Jak zaktualizować niniejszą Politykę prywatności;</p>
                <p>Załącznik - tabela 1: szczegóły dotyczące zewnętrznego pakietu SDK</p>
                <p>Podsumowując, naszym celem jest zapewnienie jak najlepszych doświadczeń użytkownika. Jeśli masz jakiekolwiek
                    pytania dotyczące niniejszej Polityki prywatności, utworzyliśmy specjalny dział i personel ds. prywatności, z
                    którymi możesz się skontaktować tak, jak zaprezentowano w Części 7 niniejszej Polityki prywatności. Odpowiemy
                    zgodnie z polityką i prawem każdego kraju. Jeśli nie jesteś zadowolony z naszej odpowiedzi, zwłaszcza jeśli
                    uważasz,
                    że nasze przetwarzanie danych osobowych naruszyło Twoje uzasadnione prawa i interesy, możesz również złożyć
                    pozew do
                    sądu właściwego, złożyć skargę do rządowych organów regulacyjnych i innych kanałów zewnętrznych, aby rozwiązać
                    problem.</p>
                <ol>
                    <li><strong>Jakie informacje zbieramy i jak je wykorzystujemy?</strong></li>
                </ol>
                <p>Dane osobowe odnoszą się do danych zapisanych elektronicznie lub w inny sposób, które umożliwiają identyfikację
                    konkretnej osoby samodzielnie lub poprzez powiązanie z innymi informacjami.</p>
                <p>Wrażliwe dane osobowe odnoszą się do danych osobowych, które po ujawnieniu, nielegalnym przekazaniu lub
                    wykorzystaniu, mogą zagrażać bezpieczeństwu osobistemu i majątkowemu, łatwo prowadzić do utraty reputacji,
                    uszczerbku na zdrowiu fizycznym i psychicznym lub dyskryminującego traktowania. W tym między innymi numer dowodu
                    osobistego, osobiste dane biometryczne, numer konta bankowego, informacje o nieruchomości, informacje o
                    lokalizacji,
                    transakcjach i dane osobowe dzieci poniżej 14 roku życia.</p>
                <p>Gromadzimy dane osobowe głównie w celu dostarczania Państwu produktów i/lub usług oraz w celu zapewnienia
                    zgodności
                    z obowiązującymi przepisami prawa, regulacjami i innymi dokumentami regulacyjnymi. Masz prawo podać te
                    informacje
                    według własnego uznania, ale w większości przypadków, jeśli tego nie zrobisz, możemy nie być w stanie zapewnić
                    Ci
                    odpowiednich usług lub odpowiedzieć na Twoje pytania.</p>
                <ol>
                    <li>Sytuacje, w których podstawowe usługi Dreamehome gromadzą i przetwarzają Twoje dane osobowe:<ol>
                        <li>Aplikacja Dreamehome łączy i zarządza inteligentnymi urządzeniami sprzętowymi;</li>
                    </ol>
                    </li>
                </ol>
                <p>Aby świadczyć usługi Dreamehome i umożliwić Ci bezpieczne łączenie się z inteligentnymi urządzeniami sprzętowymi
                    i
                    zarządzanie nimi, możemy gromadzić informacje o Twojej sieci Wi-Fi, informacje o lokalizacji, informacje o
                    koncie
                    logowania, informacje o telefonie komórkowym, informacje o inteligentnym sprzęcie i śledzenie informacji
                    powiązane z
                    Twoim kontem i inteligentnym urządzeniem sprzętowym. Informacje te zostaną wykorzystane do zapewnienia
                    inteligentnego szybkiego połączenia urządzenia sprzętowego, połączenia, wykrywania pobliskich urządzeń i funkcji
                    zarządzania urządzeniami. Powyższe informacje są wymienione w następujący sposób:</p>
                <p>Informacje o koncie logowania: nazwa konta, hasło, login, zdjęcie profilowe, adres e-mail, numer telefonu
                    komórkowego. <strong>Nazwa użytkownika, hasło, numer telefonu komórkowego i adres e-mail to poufne informacje
                        osobiste.</strong> Celem zbierania takich informacji jest zalogowanie się do serwera śledzenia konta w celu
                    uwierzytelnienia tożsamości użytkownika i uzyskania zgody konta Dreamehome na dostęp do serwera. Informacje
                    uwierzytelniające dotyczące nazwy użytkownika konta i hasła logowania zostaną zaszyfrowane i przesłane do
                    serwera
                    śledzenia konta w celu uwierzytelnienia logowania.</p>
                <p>Informacje o telefonie komórkowym: identyfikator urządzenia sprzętowego (IMEI/OAID, adres Mac, identyfikator
                    Androida), model telefonu, informacje o wersji systemu, język systemu, kraj lub region telefonu, rozmiar i
                    rozdzielczość ekranu telefonu, procesor i informacje o urządzeniu wyświetlającym. Celem zbierania tych
                    informacji
                    jest umożliwienie aplikacji Dreamehome połączenia z inteligentnymi urządzeniami sprzętowymi.</p>
                <p>Informacje o inteligentnych urządzeniach sprzętowych: nazwa, model, wersja, producent, identyfikator urządzenia,
                    adres MAC, adres IP, stan działania urządzenia, atrybuty zdefiniowane przez użytkownika, parametry ustawień,
                    zdarzenia serwisowe oraz zapisy kontroli i użytkowania urządzenia. Zebrane informacje są wykorzystywane do
                    łączenia
                    inteligentnych urządzeń sprzętowych, kontrolowania i zarządzania urządzeniami, ustawiania właściwości i
                    parametrów
                    urządzeń oraz przeglądania stanu pracy urządzenia i zapisów historycznych.</p>
                <ul>
                    <li>
                        <ol>
                            <li>Aktualizacja aplikacji Dreamehome i inteligentnych urządzeń sprzętowych:</li>
                        </ol>
                    </li>
                </ul>
                <p>Aby umożliwić Ci dalsze korzystanie z najnowszej usługi Dreamehome, możemy wykorzystać informacje o wersji Twojej
                    aplikacji Dreamehome i modelu telefonu, aby zapewnić Ci usługę aktualizacji aplikacji Dreamehome. Jednocześnie
                    możemy zbierać informacje o liście i numerach wersji inteligentnych urządzeń sprzętowych, które podłączyłeś, aby
                    zapewnić Ci funkcję aktualizacji inteligentnych urządzeń sprzętowych, aby można było korzystać z najnowszej
                    wersji
                    usługi (w tym wersji oprogramowania systemu). Dreamehome zapewnia ścieżkę aktualizacji tylko dla inteligentnych
                    urządzeń sprzętowych. Wersję oprogramowania inteligentnych urządzeń sprzętowych dostarcza producent
                    inteligentnych
                    urządzeń sprzętowych, który odpowiada za jakość wersji i wyniki aktualizacji.</p>
                <p>Jeśli nie podasz tych informacji, nie będziesz mógł zaktualizować nowych wersji aplikacji Dreamehome i
                    oprogramowania sprzętowego inteligentnego urządzenia.</p>
                <ul>
                    <li>
                        <ol>
                            <li>Informacja zwrotna o problemie online:</li>
                        </ol>
                    </li>
                </ul>
                <p>Aby pomóc Ci skuteczniej rozwiązywać problemy, które mogą wystąpić w aplikacji Dreamehome i inteligentnych
                    urządzeniach sprzętowych, udostępniamy Ci internetowy kanał informacji zwrotnej o problemach. Aby zrealizować
                    powyższe funkcje, musimy zebrać od Ciebie następujące informacje: Dreamehome zbiera informacje z dziennika
                    aplikacji
                    i urządzenia, dane kontaktowe, opis problemu oraz zdjęcia i filmy przedstawiające problem. Dzienniki aplikacji i
                    urządzeń zawierają stan urządzenia, informacje wykryte przez czujniki, zapisy pracy urządzenia oraz
                    identyfikatory
                    urządzeń. Takie informacje są zbierane w celu analizy i lokalizacji usterek. Celem zbierania Twoich danych
                    kontaktowych jest sprawdzenie czy problem został w pełni rozwiązany, lub skontaktowanie się z Tobą w celu
                    uzyskania
                    dodatkowych informacji, jeśli to konieczne.</p>
                <p>Będziemy wykorzystywać Twoje dane osobowe w następujący sposób: wyłącznie w celu uzyskania informacji zwrotnej na
                    temat lokalizacji problemu i rozwiązania, nie do wyświetlania danych osobowych i nie do rozpowszechniania reklam
                    komercyjnych. Jeśli nie podasz takich informacji, nie będziesz w stanie skutecznie zlokalizować i rozwiązać
                    zgłaszanych problemów.</p>
                <ol>
                    <li> Zbieramy i przetwarzamy Twoje dane osobowe poza podstawowymi usługami świadczonymi przez Dreamehome</li>
                </ol>
                <p>Oprócz podstawowych usług Dreamehome, Twoje dane osobowe mogą być również gromadzone i wykorzystywane w
                    następujących dodatkowych funkcjach. Jeśli nie podasz tych danych osobowych, nadal możesz korzystać z
                    podstawowych
                    usług Dreamehome, ale możesz nie być w stanie korzystać z tych dodatkowych funkcji, które mogą być dla Ciebie
                    wygodne. Te dodatkowe funkcje obejmują: Plan poprawy doświadczenia użytkownika:</p>
                <p>Aby poprawić wrażenia użytkownika, musimy zbierać następujące informacje: Dzienniki Dreamehome, w tym dzienniki
                    kluczowych procesów, dzienniki zdarzeń, dzienniki błędów, zdarzenia serwisowe oraz korzystanie z każdego
                    interfejsu
                    Aplikacji po zaszyfrowaniu. Poufne informacje o Tobie nie będą zapisywane w logach.</p>
                <p>Będziemy wykorzystywać Twoje dane osobowe w następujący sposób: automatycznie zbierając powyższe informacje i
                    przesyłając je na serwer, analizując informacje z dziennika, aby zdiagnozować stan działania urządzenia i
                    przeanalizować korzystanie z Aplikacji.</p>
                <p>Jeśli nie podasz tych informacji, Dreamehome nie będzie w stanie zwiększyć komfortu użytkownika, ale nie wpłynie
                    to
                    na podstawowe funkcje korzystania z Usługi. </p>
                <ol>
                    <li>Okoliczności, w których pozyskujemy Twoje dane osobowe od strony trzeciej</li>
                </ol>
                <p>W pewnych okolicznościach prawnych możemy uzyskać Twoje dane osobowe od stron trzecich. Jak na przykład: Za Twoją
                    zgodą będziemy współpracować z zewnętrznymi dostawcami usług w zakresie zarządzania inteligentnymi urządzeniami
                    sprzętowymi innych firm, co wiąże się z pozyskiwaniem Twoich danych osobowych od zewnętrznych dostawców usług. W
                    ramach usługi zarządzania urządzeniami innej firmy uzyskamy następujące dane osobowe pod warunkiem, że powiążesz
                    konto osoby trzeciej:</p>
                <p>Informacje o koncie strony trzeciej, w tym pseudonim, awatar, do wyświetlenia w aplikacji
                    Dreamehome;<br />Informacje o urządzeniu i sieci, w tym identyfikatory urządzeń, adresy MAC i numery seryjne
                    urządzeń, są wykorzystywane do identyfikowania działających urządzeń i wykonywania kontroli bezpieczeństwa
                    urządzeń.
                </p>
                <p>Jeśli będziemy musieli przetwarzać Twoje dane osobowe w ramach naszej działalności poza zakresem Twojej
                    autoryzowanej zgody, gdy twoje dane osobowe są przekazywane zewnętrznym dostawcom usług, uzyskamy Twoją wyraźną
                    zgodę przed przetwarzaniem Twoich danych osobowych. Ponadto będziemy ściśle przestrzegać odpowiednich przepisów
                    ustawowych i wykonawczych oraz wymagać od zewnętrznych dostawców usług ochrony legalności przekazywanych przez
                    nich
                    informacji.</p>
                <ol>
                    <li>Informacje nieosobowe</li>
                </ol>
                <p>Możemy również zbierać inne informacje, których nie można zidentyfikować z konkretną osobą (tj. informacje, które
                    nie należą do danych osobowych), takie jak dane statystyczne generowane podczas korzystania z określonej usługi,
                    takie jak zachowanie użytkownika (w tym ilość kliknięć, zmiana przeglądanych stron, czas przeglądania). Celem
                    zbierania takich informacji jest ulepszanie świadczonych przez nas usług. Rodzaj i ilość gromadzonych informacji
                    zależy od tego, w jaki sposób korzystasz z naszych produktów i/lub usług. Gromadzimy te informacje, aby pomóc
                    nam w
                    dostarczaniu naszym klientom bardziej przydatnych informacji o tym, które części naszych stron internetowych,
                    produktów i usług są dla nich najbardziej interesujące, abyśmy mogli zoptymalizować nasze interfejsy usług. Na
                    potrzeby niniejszej Polityki prywatności dane zagregowane są uważane za dane nieosobowe. Jeśli użyjemy Danych
                    nieosobowych w połączeniu z Danymi osobowymi, takie informacje będą traktowane jako dane osobowe na czas takiego
                    połączenia.</p>
                <ol>
                    <li><strong>W jaki sposób wykorzystujemy pliki cookies i podobne technologie?</strong></li>
                </ol>
                <p>Aby mieć pewność, że Dreamehome działa poprawnie, przechowujemy na Twoim urządzeniu mały plik danych o nazwie
                    Cookies. Pliki cookies zazwyczaj zawierają identyfikatory, nazwy witryn oraz niektóre cyfry i znaki. Za pomocą
                    plików cookies Dreamehome może przechowywać login do witryny, preferencje i inne dane.</p>
                <p>Nie używamy plików cookies do celów innych niż określone w niniejszym oświadczeniu. Możesz zarządzać lub usuwać
                    pliki cookies zgodnie ze swoimi preferencjami. Jeśli jednak to zrobisz, w niektórych przypadkach możesz zagrozić
                    bezpiecznemu dostępowi do Dreamehome i będziesz musiał osobiście zmieniać Ustawienia użytkownika za każdym
                    razem,
                    gdy odwiedzasz Dreamehome.</p>
                <ol>
                    <li><strong>W jaki sposób powierzamy, udostępniamy, przekazujemy i publicznie ujawniamy Twoje dane
                        osobowe?</strong>
                    </li>
                    <li>Powierzenie</li>
                </ol>
                <p>W normalnych okolicznościach możemy powierzyć innym firmom przetwarzanie Twoich danych osobowych w naszym
                    imieniu.
                    Na przykład firmy, które kontaktują się z Tobą, wysyłają Ci wiadomości e-mail lub zapewniają pomoc techniczną w
                    naszym imieniu, mogą wykorzystywać Twoje dane osobowe wyłącznie w celu świadczenia usług w naszym imieniu.</p>
                <p>Ścisła umowa o zachowaniu poufności lub klauzula o przetwarzaniu danych osobowych zostanie podpisana ze stroną
                    powierzającą, zobowiązując ją do postępowania z danymi osobowymi zgodnie z niniejszą Polityką prywatności i
                    podjęcia
                    odpowiednich środków poufności i bezpieczeństwa.</p>
                <ol>
                    <li>Udostępnianie</li>
                </ol>
                <p>W normalnych okolicznościach nie udostępnimy publicznie Twoich danych osobowych, z wyjątkiem następujących
                    okoliczności:</p>
                <ul>
                    <li>
                        <ol>
                            <li>Po uzyskaniu Twojej wyraźnej zgody udostępnimy informacje w zakresie Twojego upoważnienia wskazanej
                                przez
                                Ciebie stronie trzeciej; Obejmuje to udostępnianie informacji i konfiguracji produktów
                                inteligentnego domu
                                znajomym i krewnym na żądanie użytkownika, aby pomóc znajomym i krewnym w szybkim korzystaniu z
                                oprogramowania
                                i usług za pośrednictwem ich urządzeń końcowych.<br /></li>
                            <li>Treść usług Dreamehome jest dostarczana przez zewnętrznych dostawców usług i w tym celu musimy
                                dostarczyć
                                zewnętrznym dostawcom usług pewne dane osobowe, takie jak hosting, analiza danych, płatności i
                                przetwarzanie
                                kart kredytowych, infrastruktura dostaw, usługi IT, usługi obsługi klienta, usługi poczty e-mail i
                                inne
                                podobne usługi. Działanie te podjęte są w celu zapewnienia możliwości dostarczenia usług przez
                                stronę
                                trzecią.<br />.</li>
                            <li>Udostępniamy Twoje dane osobowe klientom i innym partnerom biznesowym, którzy bezpośrednio lub
                                pośrednio
                                dostarczają Ci inteligentne urządzenia sprzętowe i/lub sieci i systemy, z których korzystasz w celu
                                uzyskania
                                dostępu do naszych Witryn i usług oraz korzystania z nich.<br /></li>
                            <li>Udostępniamy Twoje dane osobowe podmiotom stowarzyszonym lub innym stronom trzecim w przypadku
                                reorganizacji, fuzji, sprzedaży, wspólnego przedsięwzięcia, cesji, przeniesienia lub innego zbycia
                                całości lub
                                części naszej działalności, aktywów lub akcji (w tym między innymi powyżej w związku z jakimkolwiek
                                postępowaniem upadłościowym lub podobnym). W takim przypadku otrzymasz powiadomienie e-mailem i/lub
                                poprzez
                                naszą stronę internetową o zmianach własności, niezgodnościach w nowym wykorzystaniu danych
                                osobowych i
                                wyborach dotyczących danych osobowych.<br /></li>
                            <li>W zakresie, w jakim uznamy to za konieczne lub właściwe :(a) w celu przestrzegania obowiązujących
                                przepisów
                                i regulacji; (b) w celu zapewnienia zgodności z procedurami prawnymi; (c) w celu odpowiadania na
                                prośby
                                organów publicznych i organów rządowych, w tym spoza kraju/terytorium, w którym mieszkasz; (d) w
                                celu
                                realizacji naszych warunków; (e) w celu ochrony naszych operacji i systemów; (f) w celu ochrony
                                prawa,
                                prywatności, bezpieczeństwa lub własności naszych i/lub innych użytkowników, w tym Ciebie; Oraz (g)
                                w celu
                                szukania dostępnych środków zaradczych lub ograniczania szkody, które możemy być zmuszeni
                                zapewnić.<br /></li>
                            <li>Udostępniamy Twoje dane osobowe spółkom zależnym lub stowarzyszonym spółkom w celu regularnego
                                prowadzenia
                                działalności biznesowej.<br /></li>
                            <li>Będziemy udostępniać niezbędne dane stronom trzecim za pośrednictwem interfejsu aplikacji (API) i
                                zestawu
                                narzędzi programistycznych (SDK). W zależności od wersji pakietu SDK stron trzecich mogą zachodzić
                                pewne
                                różnice, ogólnie obejmując logowanie do konta stron trzecich, udostępnianie, płatności stron
                                trzecich,
                                informacje od dostawcy, statystyki itp. Przeprowadzimy rygorystyczne testy bezpieczeństwa dla stron
                                trzecich i
                                uzgodnimy środki ochrony danych. Załącznik 1 zawiera szczegóły pakietu SDK strony trzeciej, który
                                został
                                upoważniony do dostępu do danych osobowych. Należy go uważnie przeczytać. Nasza polityka prywatności
                                nie
                                dotyczy produktów lub usług dostarczanych przez strony trzecie. Informacje o Tobie mogą być również
                                gromadzone
                                podczas korzystania z tych produktów lub usług. Dlatego zdecydowanie zalecamy poświęcenie czasu na
                                zapoznanie
                                się z polityką prywatności strony trzeciej, tak jak z naszą polityką. Nie ponosimy odpowiedzialności
                                za
                                sposób, w jaki strony trzecie wykorzystują dane osobowe, które od Ciebie gromadzą, ani nie możemy
                                kontrolować
                                ich wykorzystania. Nasza polityka prywatności nie ma zastosowania do innych witryn, do których
                                prowadzą linki
                                za pośrednictwem naszych usług. To Ty jako użytkownik, jesteś jedyna stroną decyzyjną do korzystania
                                z
                                podlinkowanej strony internetowej. Zanim po raz pierwszy wejdziesz na stronę internetową strony
                                trzeciej,
                                dostawca usług strony trzeciej pokaże Ci odpowiednie umowy i oświadczenia o ochronie prywatności.
                                Prosimy o
                                uważne przeczytanie tych umów i oświadczeń o ochronie prywatności.<br /></li>
                        </ol>
                    </li>
                </ul>
                <ol>
                    <li>Przekazanie</li>
                </ol>
                <p>Dreame nie przekaże Twoich danych osobowych do żadnej firmy, organizacji ani osoby, z wyjątkiem następujących
                    okoliczności:</p>
                <ul>
                    <li>
                        <ol>
                            <li>Przekazywanie za wyraźną zgodą: Przekażemy Twoje dane osobowe innym podmiotom po uzyskaniu Twojej
                                wyraźnej
                                zgody;<br /></li>
                            <li>W przypadku fuzji, przejęcia lub likwidacji, jeśli chodzi o przekazanie danych osobowych, będziemy
                                wymagać,
                                aby nowa firma lub organizacja, która przechowuje Twoje dane osobowe, nadal była związana niniejszym
                                oświadczeniem; w przeciwnym razie będziemy wymagać, aby firma lub organizacja ponownie zwróciła się
                                do Ciebie
                                o upoważnienie.<br /></li>
                        </ol>
                    </li>
                </ul>
                <ol>
                    <li>Ujawnienie publiczne</li>
                </ol>
                <p>Twoje dane osobowe ujawnimy publicznie tylko w następujących okolicznościach:</p>
                <ul>
                    <li>
                        <ol>
                            <li> Po uzyskaniu Twojej wyraźnej zgody;<br /></li>
                            <li> Ujawnienie na podstawie prawa: Możemy publicznie ujawnić Twoje dane osobowe zgodnie z prawem lub
                                zgodnie z
                                obowiązkowymi wymogami procedur prawnych, procesów sądowych lub organów rządowych.</li>
                        </ol>
                    </li>
                </ul>
                <ol>
                    <li> Jak przechowujemy i chronimy Twoje dane osobowe?</li>
                </ol>
                <p>Przechowujemy Dane osobowe przez okres niezbędny do celów, dla których informacje są gromadzone, zgodnie z opisem
                    w
                    niniejszej Polityce prywatności lub zgodnie z obowiązującymi przepisami prawa. Po zrealizowaniu celu gromadzenia
                    danych osobowych lub po potwierdzeniu Twojego wniosku o usunięcie lub anulowanie, lub po zakończeniu działania
                    odpowiednich produktów lub usług, przestaniemy przechowywać dane osobowe i usuniemy je lub zanonimizujemy. Z
                    uwagi
                    na interes publiczny, cele naukowe, historyczne lub statystyczne, będziemy nadal przechowywać odpowiednie dane
                    na
                    podstawie obowiązującego prawa, nawet jeśli dalsze przetwarzanie danych nie jest związane z pierwotnym celem
                    gromadzenia.</p>
                <p>W działalności Dreamehome Twoje dane osobowe będą przechowywane w następujący sposób:</p>
                <p>W przypadku danych przechowywanych lokalnie w aplikacji Dreamehome, po odinstalowaniu aplikacji Dreamehome lub
                    wyczyszczeniu danych aplikacji Dreamehome wszystkie przechowywane dane zostaną natychmiast usunięte. W przypadku
                    inteligentnych urządzeń sprzętowych Dreamehome i danych biznesowych przechowywanych na serwerze, gdy usuniesz
                    inteligentne urządzenia sprzętowe, odmówisz wyrażenia zgody na politykę prywatności Dreamehome i przestaniesz
                    korzystać z usługi Dreamehome, wszystkie przechowywane dane zostaną natychmiast usunięte. Zapisane na serwerze
                    logi
                    serwisowe, statystyki oraz zapisy historyczne są usuwane przy okresowym usuwaniu danych serwera. Dane są zwykle
                    przechowywane krócej niż dwa lata. Ponadto, gdy nasze produkty lub usługi przestaną działać, powiadomimy Cię o
                    tym w
                    formie komunikatu, ogłoszenia lub w innych formie oraz usuniemy Twoje dane osobowe lub zanonimizujemy je w
                    rozsądnym
                    czasie.</p>
                <p><strong>5. Twoje prawa</strong></p>
                <p>1. Dostęp, poprawianie i usuwanie swoich danych osobowych</p>
                <p>Zgodnie z obowiązującymi krajowymi lub regionalnymi przepisami ustawowymi i wykonawczymi, masz prawo zażądać
                    dostępu, poprawienia lub usunięcia wszelkich posiadanych przez nas danych osobowych związanych z Tobą (zwane
                    dalej
                    „Żądaniem”). Skontaktuj się z nami listownie lub odwiedzając Dreamehome. Większość przepisów wymaga, aby wnioski
                    składane przez podmiot danych osobowych były zgodne z określonymi wymogami. Niniejsza Polityka prywatności
                    wymaga,
                    aby Twoje żądania były zgodne z następującymi warunkami:</p>
                <p>Za pośrednictwem naszych dedykowanych kanałów składania wniosków i w celu ochrony bezpieczeństwa Twoich
                    informacji,
                    Twoje żądanie powinno mieć formę pisemną (chyba że lokalne prawo wyraźnie uznaje prośby ustne);</p>
                <p>Należy podać wystarczające informacje, aby umożliwić nam zweryfikowanie Twojej tożsamości i upewnić się, że
                    wnioskodawca jest podmiotem żądanych informacji sam lub jest prawnie upoważnioną osobą;</p>
                <p>Po uzyskaniu wystarczających informacji, aby potwierdzić, że możemy przetworzyć Twoje żądanie, odpowiemy na nie w
                    czasie wymaganym przez obowiązujące przepisy o ochronie danych. Konkretnie, zgodnie z przepisami obowiązującego
                    prawa możemy bezpłatnie udostępnić rejestr Twoich danych osobowych, które zebraliśmy i przetworzyliśmy. Jeśli
                    złożysz dodatkowe prośby o odpowiednie informacje, pobierzemy opłatę w zasadnej wysokości na podstawie
                    obowiązujących przepisów i rzeczywistych kosztów administracyjnych.</p>
                <p>Jeśli uważasz, że jakiekolwiek informacje, które posiadamy na Twój temat, są nieprawidłowe lub niekompletne,
                    możesz
                    zażądać poprawienia lub udoskonalenia danych osobowych do celów użytkowych.</p>
                <p>W zależności od obowiązujących przepisów i regulacji masz prawo złożyć żądanie o usunięcie Twoich danych
                    osobowych.
                    Zgodnie z odpowiednimi przepisami, ocenimy Twoje żądanie i podejmiemy odpowiednie kroki, w tym środki techniczne
                    do
                    przetworzenia żądania. Pomożemy Ci usunąć odpowiednie dane, jednakże ze względu na obowiązujące przepisy i
                    technologie bezpieczeństwa, możemy nie być w stanie natychmiast usunąć odpowiednich informacji z systemu kopii
                    zapasowych. Będziemy bezpiecznie przechowywać Twoje dane osobowe i powstrzymywać się od dalszego ich
                    przetwarzania,
                    dopóki kopia zapasowa nie zostanie usunięta lub anonimowa. Na przykład, zgodnie z Ustawą o handlu elektronicznym
                    Chińskiej Republiki Ludowej, Twoje informacje o towarach i usługach oraz informacje o transakcjach będą
                    przechowywane przez co najmniej trzy lata od daty zakończenia transakcji.</p>
                <p>Mamy prawo odmówić rozpatrzenia błahych/powtarzających się żądań, takich, które naruszają prywatność innych,
                    wyjątkowo nierealistycznych, o nieadekwatną pracę techniczną, takich, które nie muszą być składane zgodnie z
                    lokalnym prawem, informacji, które zostały upublicznione, oraz informacje podane w warunkach poufnych. Możemy
                    również odrzucić wnioski o usunięcie lub dostęp do danych, jeśli uważamy, że niektóre aspekty żądania mogą
                    uniemożliwić nam korzystanie z danych zgodnie z prawem do celów przeciwdziałania oszustwom i bezpieczeństwa
                    opisanych powyżej.</p>
                <p>2. Wycofanie zgody</p>
                <p>Możesz odwołać zgodę, przesyłając żądanie, w tym dotyczące zbierania, wykorzystywania i/lub ujawniania swoich
                    danych osobowych będących w naszym posiadaniu lub pod naszą kontrolą. W zależności od używanych przez Ciebie
                    konkretnych usług, możesz skontaktować się z nami, korzystając z danych kontaktowych w sekcji 7 niniejszej
                    Polityki
                    prywatności w celu przeprowadzenia odpowiednich operacji. Przetworzymy Twoje żądanie w rozsądnym czasie po jego
                    złożeniu i nie będziemy gromadzić, wykorzystywać i/lub ujawniać Twoich danych osobowych na podstawie Twojego
                    żądania.</p>
                <p>Należy pamiętać, że w zależności od zakresu, w jakim upoważniasz nas do przetwarzania informacji, wycofanie zgody
                    może spowodować, że nie będziesz mógł korzystać z usług Dreamehome lub jego inteligentnych produktów
                    sprzętowych.
                    Jednak Twoja decyzja o wycofaniu zgody lub upoważnienia nie wpłynie na wcześniejsze przetwarzanie danych
                    osobowych
                    na podstawie Twojego upoważnienia.</p>
                <p>Możesz wycofać swoją zgodę na wykorzystanie tych danych osobowych, żądając cofnięcia zgody lub przechodząc do
                    strony Dreamehome, aby wprowadzić zmiany w celu wyjścia z Programu poprawy komfortu użytkownika.</p>
                <p>3. Anulowanie konta Dreamehome</p>
                <p>Możesz wylogować się z konta Dreamehome, odwiedzając Ja &gt; Ustawienia konta &gt; Wyloguj. Możesz nie być w
                    stanie
                    korzystać z Dreamehome i całej linii inteligentnych produktów i usług sprzętowych, jeśli anulujesz konto
                    Dreamehome.
                    Należy zachować ostrożność. W celu ochrony uzasadnionych praw i interesów Ciebie lub innych osób, ocenimy, czy
                    wspierać Twoje żądanie o anulowaniu w oparciu o korzystanie z różnych inteligentnych produktów sprzętowych i
                    usług
                    Dreamehome.</p>
                <p><strong>6. Transgraniczna transmisja danych</strong></p>
                <p>Ponieważ dostarczamy nasze produkty lub usługi za pośrednictwem zasobów i serwerów zlokalizowanych na całym
                    świecie, oznacza to, że za Twoją autoryzowaną zgodą Twoje dane osobowe mogą być przekazywane lub udostępniane
                    z/do
                    innych jurysdykcji w krajach/terytoriach, w których korzystasz z Produktów lub usług. Środki ochrony danych i
                    inne
                    przepisy prawne w krajach, do których mogą być przesyłane Twoje dane, mogą nie być tak kompleksowe, jak te w
                    Twoim
                    kraju ojczystym. W takich przypadkach podejmiemy odpowiednie i zgodne z prawem środki, zgodnie z obowiązującym
                    prawem każdej jurysdykcji, aby zapewnić, że Twoje dane osobowe będą nadal chronione.</p>
                <p>Uwaga:</p>
                <p>Jeśli jesteś mieszkańcem Europejskiego Obszaru Gospodarczego (EOG), a Twoje dane osobowe są przekazywane poza
                    EOG,
                    będziemy: przetwarzać Twoje dane osobowe w obszarze, który został określony przez Komisję w celu zapewnienia
                    odpowiedniego poziomu ochrony; Lub wdrażać odpowiednie zabezpieczenia w celu ochrony danych osobowych, w tym
                    transmisji zgodnie z obowiązującymi mechanizmami transmisji, takimi jak standardowe warunki umowne Komisji
                    Europejskiej.</p>
                <p><strong>7. Skontaktuj się z nami</strong></p>
                <p>Jeśli masz jakiekolwiek uwagi lub pytania dotyczące niniejszej Polityki prywatności lub jeśli masz jakiekolwiek
                    pytania dotyczące naszego gromadzenia, wykorzystywania lub ujawniania Twoich danych osobowych, skontaktuj się z
                    nami
                    pod adresem podanym poniżej lub odwiedzając podstronę <strong>Ja &gt; Obawy i opinie</strong> i wskaz „Politykę
                    prywatności". Nasz profesjonalny zespół odpowie i doradzi w przypadku jakiekolwiek wątpliwości dotyczących
                    danych
                    osobowe. Jeśli Twoje pytanie dotyczy poważniejszej sprawy, poprosimy Cię o więcej informacji. Jeśli nie jesteś
                    zadowolony z otrzymanej odpowiedzi, możesz skierować skargę do odpowiedniego organu regulacyjnego w swojej
                    jurysdykcji. Jeśli skonsultujesz się z nami, udzielimy Ci informacji o odpowiednich drogach reklamacji, które
                    mogą
                    mieć zastosowanie, w zależności od Twojej sytuacji.</p>
                <p>Adres e-mail:</p>
                <p>• Dane kontaktowe w Chinach: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></p>
                <p>• Inspektor ochrony danych osobowych w Singapurze: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></p>
                <p>• Przedstawiciele UE: <a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></p>
                <p>Numer kontaktowy: 400-875-9511</p>
                <p>Strona internetowa: <a className="page"
                    href="https://www.dreametech.com">https://www.dreametech.com</a></p>
                <p><strong>8. Jak zaktualizować niniejszą Politykę prywatności?</strong></p>
                <p>Zastrzegamy sobie prawo do aktualizacji niniejszej polityki w rozsądnym czasie. Gdy niniejsza polityka
                    prywatności
                    zostanie zmieniona, poinformujemy Cię o zmienionej polityce za pomocą wyskakujących okienek lub w inny widoczny
                    sposób. Będziemy gromadzić, wykorzystywać i przechowywać Twoje dane osobowe zgodnie z naszymi zaktualizowanymi
                    zasadami wyłącznie po uzyskaniu Twojej zgody.</p>
                <p>Niniejsza polityka wchodzi w życie z dniem odnowienia.</p>
                <p>Data ostatniej aktualizacji: 28 sierpnia 2021 r.</p>
                <p><strong>Załącznik – tabela 1: Szczegóły dotyczące zewnętrznego pakietu SDK</strong></p>
                <p>*W celu zapewnienia bardziej profesjonalnych i bezpiecznych usług podstawowych i dodatkowych funkcji, Dreamehome
                    uzyska dostęp do produktów SDK innych firm. Obecnie produkty SDK innych firm w Dreamehome są ujawniane w
                    następujący
                    sposób:</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>Usługa SDK</p>
                        </td>
                        <td>
                            <p>Dokładna funkcja</p>
                        </td>
                        <td>
                            <p>Dostęp do informacji</p>
                        </td>
                        <td>
                            <p>Polityka prywatności strony trzeciej</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Analiza statystyczna Umeng SDK</p>
                        </td>
                        <td>
                            <p>Analiza statystyczna</p>
                        </td>
                        <td>
                            <p>Identyfikator urządzenia (IMEI/Mac/android ID/IDFA/OPENUDID/GUID、karta SIM, wiadomość IMSI), pozycja
                                geograficzna</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Komunikaty push Umeng SDK</p>
                        </td>
                        <td>
                            <p>Komunikaty push </p>
                        </td>
                        <td>
                            <p>Identyfikator urządzenia (IMEI/Mac/android ID/IDFA/OPENUDID/GUID、karta SIM, wiadomość IMSI), pozycja
                                geograficzna</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng Pakiet SDK do udostępniania społecznościowego </p>
                        </td>
                        <td>
                            <p>Udostępnianie trzeciej stronie</p>
                        </td>
                        <td>
                            <p>Identyfikator urządzenia (IMEI/Mac/android ID/IDFA/OPENUDID/GUID、karta SIM, wiadomość IMSI),
                                położenie
                                geograficzne</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>Połączenie z mikrofonem, streaming wideo</p>
                        </td>
                        <td>
                            <p>Informacje o urządzeniu, status połączenia internetowego, aparat, mikrofon, miejsce odczytu/zapisu
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Wiadomości push Huawei SDK</p>
                        </td>
                        <td>
                            <p>Komunikaty push</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Wiadomości push Xiaomi SDK</p>
                        </td>
                        <td>
                            <p>Komunikaty push</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu (w tym logi twórców strony trzeciej, logcat i informacje o awarii aplikacji),
                                ID
                                urządzenia (w tym Adroidid)</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Komunikaty push OPPO SDK</p>
                        </td>
                        <td>
                            <p>Komunikaty push</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Komunikaty push VIVO SDK</p>
                        </td>
                        <td>
                            <p>Komunikaty push</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>Logowanie WeChat trzeciej strony, udostępnianie WeChat</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu, informacje o połączeniu internetowym</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Udostępnianie</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu, informacje o połączeniu</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Logowanie Weibo trzeciej strony, udostępnianie Weibo</p>
                        </td>
                        <td>
                            <p>Informacje o logowaniu, informacje o połączeniu</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>AppleID SDK</p>
                        </td>
                        <td>
                            <p>Logowanie Apple ID</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
                <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy